import { createSelector } from '@reduxjs/toolkit';
import { DefaultRootState } from 'react-redux';
import { sortLeads } from '../../plot/utils/lead';
import { RAW_SIGNAL_STRIP_ID } from '../components/RawSignalPlot';

const rawSignalStateSelector = ({ rawSignal }: DefaultRootState) => rawSignal;

export const rawSignalLeadsSelector = createSelector(
  rawSignalStateSelector,
  ({ leads }) => leads,
);

export const rawSignalLeadNamesSelector = createSelector(
  rawSignalLeadsSelector,
  (leads) => Object.keys(leads).sort(sortLeads),
);

export const rawSignalFrequencySelector = createSelector(
  rawSignalStateSelector,
  ({ frequency }) => frequency,
);

export const rawSignalMeanSelector = createSelector(
  rawSignalStateSelector,
  ({ means }) => means,
);

export const designatedMeanSelector = (stripId: string, leadName: string) =>
  createSelector(rawSignalMeanSelector, (means) => {
    switch (stripId) {
      case RAW_SIGNAL_STRIP_ID:
        return means[leadName];
      default:
        return 0;
    }
  });
